import React from 'react';
import { Outlet, useNavigate } from 'react-router-dom';
import { IconButton } from '@mui/material';
import { OutlinedIcons, SecondaryAppBar } from '@marageti/z4-lib';

const View = () => {
  const navigate = useNavigate();

  const handleClick = () => {
    navigate(-1);
  };

  return (
    <>
      <SecondaryAppBar
        position="sticky"
        startAdornment={(
          <IconButton onClick={handleClick} edge="start">
            <OutlinedIcons.OutlinedArrowSmLeftIcon color="primary" />
          </IconButton>
      )}
      />
      <Outlet />
    </>
  );
};

export default View;
